export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"google","content":"notranslate"}],"link":[{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preload","as":"style","href":"https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;500;600;700&display=swap","onload":"this.onload=null;this.rel='stylesheet'"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;500;600;700&display=swap","media":"print","onload":"this.media='all'"},{"rel":"preconnect","href":"https://www.google-analytics.com"},{"rel":"preconnect","href":"https://eu.app.unleash-hosted.com"},{"rel":"preconnect","href":"https://www.googletagmanager.com"}],"style":[],"script":[],"noscript":[{"innerHTML":"<link rel=\"stylesheet\" href=\"https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;500;600;700&display=swap\">"}],"htmlAttrs":{"translate":"no"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const vueAppRootContainer = '#__nuxt'